import React from 'react';
import { OrderSearchParameter } from '@zonofi/zono-money-store';
import { Text } from '../../common';

export const getSearchResultString = (
  searchParameter: OrderSearchParameter,
  searchResult: any[]
) => {
  return searchParameter?.parameterId === 'userId' ? (
    <>
      Order by: <Text className="font-semibold">{searchParameter?.value}</Text>{' '}
      ({searchResult?.length} found)
    </>
  ) : (
    <>
      {searchResult?.length} result{searchResult?.length > 1 ? 's' : ''} found
      for "<Text className="font-semibold">{searchParameter?.value}</Text>"
    </>
  );
};
